import { FC } from 'react';
import { Text } from '@mantine/core';
import { BookitupNotification } from '../../../../Types/LogT';

const PortalCreated: FC<{ notification: BookitupNotification }> = ({ notification }) => {
  const { value } = notification;
  return (
    <Text>
      Online-Portal{'  '}
      <Text span weight="bolder">
        {value}
      </Text>
      {'  '}
      erstellt.
    </Text>
  );
};

export default PortalCreated;
